var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("breadcrumb-top", {
        attrs: { breadcrumbConfig: _vm.dataList, isBack: "1" },
      }),
      _c("div", { staticClass: "content c-top" }, [
        _c("div", { staticClass: "bread-small" }, [
          _c(
            "span",
            {
              staticStyle: {
                "font-size": "18px",
                "font-weight": "bold",
                "margin-right": "7px",
              },
            },
            [_vm._v("商城管理")]
          ),
          _c("span", [_vm._v("/")]),
          _c(
            "span",
            {
              staticClass: "bread-active",
              staticStyle: {
                "margin-left": "6px",
                "margin-right": "20px",
                cursor: "pointer",
              },
            },
            [_vm._v("商城装修")]
          ),
          _c(
            "span",
            {
              staticStyle: { color: "#909099", cursor: "pointer" },
              on: { click: _vm.toPage },
            },
            [_vm._v("首页装修")]
          ),
        ]),
        _c("div", { staticClass: "page-content" }, [
          _c("div", { staticClass: "phone-view" }, [
            _vm.swicthIndex == 0
              ? _c("div", { staticClass: "phone-masker" }, [
                  _c(
                    "div",
                    {
                      staticClass: "phone-maskerimg",
                      style: {
                        "background-image": _vm.imageUrl
                          ? ""
                          : `url(${_vm.bgImg})`,
                        width: _vm.posterSize == "1" ? "250px" : "320px",
                        height: _vm.posterSize == "1" ? "300px" : "400px",
                      },
                    },
                    [
                      _vm.imageUrl
                        ? _c("img", {
                            attrs: {
                              src: _vm.imageUrl,
                              alt: "",
                              width: "100%",
                              height: "100%",
                            },
                          })
                        : _vm._e(),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm.swicthIndex == 1
              ? _c("div", { staticClass: "fenlei" }, [
                  _vm.classifyType == "1"
                    ? _c("img", {
                        staticStyle: { width: "100%", height: "100%" },
                        attrs: {
                          src: require("../../../assets/img_biaozhun@2x.png"),
                          alt: "",
                        },
                      })
                    : _vm._e(),
                  _vm.classifyType == "2"
                    ? _c("img", {
                        staticStyle: { width: "100%", height: "100%" },
                        attrs: {
                          src: require("../../../assets/img_biaoqian@2x.png"),
                          alt: "",
                        },
                      })
                    : _vm._e(),
                ])
              : _vm._e(),
            _vm.swicthIndex == 2
              ? _c(
                  "div",
                  { staticClass: "tabbar" },
                  _vm._l(_vm.navData, function (item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "tabbar-item",
                        on: {
                          click: function ($event) {
                            return _vm.swicthTabbar(index)
                          },
                        },
                      },
                      [
                        item.selectedImg && item.unSelectedImg
                          ? _c("img", {
                              staticClass: "tabbar-icon",
                              attrs: {
                                src:
                                  _vm.tabbarIndex == index
                                    ? item.selectedImg
                                    : item.unSelectedImg,
                                alt: "",
                              },
                            })
                          : _c("div", {
                              staticClass: "tabbar-icon",
                              staticStyle: { "background-color": "#d9d9da" },
                            }),
                        _c(
                          "span",
                          {
                            style: {
                              color:
                                _vm.tabbarIndex == index
                                  ? _vm.textColor || "#333"
                                  : "#999999",
                            },
                          },
                          [_vm._v(_vm._s(item.name || item.typeName))]
                        ),
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
          ]),
          _c("div", { staticClass: "page-right" }, [
            _c(
              "div",
              { staticStyle: { display: "flex", "align-items": "center" } },
              _vm._l(_vm.swicthList, function (item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "right-title",
                    class: { "right-title-active": _vm.swicthIndex == index },
                    on: {
                      click: function ($event) {
                        return _vm.swicthFn(index)
                      },
                    },
                  },
                  [_vm._v(_vm._s(item))]
                )
              }),
              0
            ),
            _c("span", { staticClass: "edit-title" }, [_vm._v("内容编辑")]),
            _c("div", { staticClass: "line" }),
            _c("div", { staticClass: "edit-top" }, [
              _c(
                "div",
                {
                  staticClass: "edit-name",
                  staticStyle: { display: "flex", "align-items": "center" },
                },
                [
                  _vm._v(" " + _vm._s(_vm.contentTitle) + " "),
                  _vm.swicthIndex == 1 || _vm.swicthIndex == 2
                    ? _c(
                        "span",
                        {
                          staticStyle: {
                            color: "#909099",
                            "font-weight": "500",
                          },
                        },
                        [_vm._v(_vm._s(_vm.contentTips))]
                      )
                    : _vm._e(),
                  _vm.swicthIndex == 0
                    ? _c(
                        "div",
                        {
                          staticClass: "edit-name",
                          staticStyle: { "margin-left": "30px" },
                        },
                        [
                          _c(
                            "el-radio",
                            {
                              attrs: { label: "1" },
                              model: {
                                value: _vm.posterSize,
                                callback: function ($$v) {
                                  _vm.posterSize = $$v
                                },
                                expression: "posterSize",
                              },
                            },
                            [_vm._v("标准尺寸（500*600px）")]
                          ),
                          _c(
                            "el-radio",
                            {
                              attrs: { label: "2" },
                              model: {
                                value: _vm.posterSize,
                                callback: function ($$v) {
                                  _vm.posterSize = $$v
                                },
                                expression: "posterSize",
                              },
                            },
                            [_vm._v("大尺寸（640*800px）")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.swicthIndex == 2
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center",
                            "margin-left": "30px",
                          },
                        },
                        [
                          _c("span", [_vm._v("选中文字颜色：")]),
                          _c("el-color-picker", {
                            model: {
                              value: _vm.textColor,
                              callback: function ($$v) {
                                _vm.textColor = $$v
                              },
                              expression: "textColor",
                            },
                          }),
                          _c("el-input", {
                            staticStyle: {
                              width: "200px",
                              "margin-left": "30px",
                            },
                            attrs: { placeholder: "输入颜色值，例：#409EFF" },
                            model: {
                              value: _vm.textColor,
                              callback: function ($$v) {
                                _vm.textColor = $$v
                              },
                              expression: "textColor",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              ),
            ]),
            _vm.swicthIndex == 0
              ? _c(
                  "div",
                  [
                    _c(
                      "el-table",
                      {
                        attrs: {
                          data: _vm.popData,
                          "header-cell-style": {
                            background: "#F5F6FA",
                            color: "#303033",
                            "font-weight": "bold",
                            "text-align": "left",
                          },
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            label: "图片",
                            prop: "imgUrl",
                            width: "150px",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("upload-picture", {
                                      attrs: { imageUrl: _vm.imageUrl },
                                      on: {
                                        getUrl: function ($event) {
                                          return _vm.getImage($event, 1)
                                        },
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2615011007
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: "关联类型",
                            prop: "navType",
                            width: "150px",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    scope.row.navType == 0
                                      ? _c("p", [_vm._v("-")])
                                      : _vm._e(),
                                    scope.row.navType == 1
                                      ? _c("p", [_vm._v("功能跳转")])
                                      : _vm._e(),
                                    scope.row.navType == 2
                                      ? _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.navType == 2 &&
                                                _vm.classifyType == "2" &&
                                                _vm.labelId
                                                ? "分类标签"
                                                : "分类类目"
                                            )
                                          ),
                                        ])
                                      : _vm._e(),
                                    scope.row.navType == 3
                                      ? _c("p", [_vm._v("商品")])
                                      : _vm._e(),
                                    scope.row.navType == 4
                                      ? _c("p", [_vm._v("页面设置")])
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1626845730
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: { label: "关联页面" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "toselect",
                                        on: { click: _vm.showDialog },
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(scope.row.funcName) + " "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3377189139
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: { label: "操作", width: "100px" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "p",
                                      {
                                        staticStyle: {
                                          color: "#F63C56",
                                          cursor: "pointer",
                                        },
                                        on: { click: _vm.deleteFn },
                                      },
                                      [_vm._v(" 删除 ")]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1505504478
                          ),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm.swicthIndex == 1
              ? _c(
                  "div",
                  [
                    _c(
                      "el-radio",
                      {
                        attrs: { label: "1" },
                        model: {
                          value: _vm.classifyType,
                          callback: function ($$v) {
                            _vm.classifyType = $$v
                          },
                          expression: "classifyType",
                        },
                      },
                      [_vm._v("标准版")]
                    ),
                    _c(
                      "el-radio",
                      {
                        attrs: { label: "2" },
                        model: {
                          value: _vm.classifyType,
                          callback: function ($$v) {
                            _vm.classifyType = $$v
                          },
                          expression: "classifyType",
                        },
                      },
                      [_vm._v("标签版")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm.swicthIndex == 2
              ? _c(
                  "div",
                  [
                    _c(
                      "el-table",
                      {
                        attrs: {
                          data: _vm.navData,
                          "header-cell-style": {
                            background: "#F5F6FA",
                            color: "#303033",
                            "font-weight": "bold",
                            "text-align": "left",
                          },
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: { label: "排序", width: "80px" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("p", [_vm._v(_vm._s(scope.$index + 1))]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            276119358
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: { label: "选中", width: "150px" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("upload-picture", {
                                      attrs: {
                                        imageUrl: scope.row.selectedImg,
                                      },
                                      on: {
                                        getUrl: function ($event) {
                                          return _vm.getImage(
                                            $event,
                                            2,
                                            scope.$index
                                          )
                                        },
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1684304936
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: { label: "未选中", width: "150px" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("upload-picture", {
                                      attrs: {
                                        imageUrl: scope.row.unSelectedImg,
                                      },
                                      on: {
                                        getUrl: function ($event) {
                                          return _vm.getImage(
                                            $event,
                                            3,
                                            scope.$index
                                          )
                                        },
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            579597682
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: { label: "名称", prop: "name" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("el-input", {
                                      attrs: {
                                        placeholder: "请输入名称",
                                        maxlength: 4,
                                        "show-word-limit": "",
                                      },
                                      model: {
                                        value: scope.row.name,
                                        callback: function ($$v) {
                                          _vm.$set(scope.row, "name", $$v)
                                        },
                                        expression: "scope.row.name",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2643455103
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: { label: "关联页面", prop: "typeName" },
                        }),
                        _c("el-table-column", {
                          attrs: { label: "操作", prop: "name" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toDefault(scope.$index)
                                          },
                                        },
                                      },
                                      [_vm._v("恢复默认")]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3360929346
                          ),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "bottom-box", staticStyle: { border: "none" } },
              [
                _c(
                  "div",
                  {
                    staticClass: "bottom-btn",
                    on: {
                      click: function ($event) {
                        return _vm.savePopupWindowTemplate(_vm.swicthIndex)
                      },
                    },
                  },
                  [_vm._v("保存")]
                ),
              ]
            ),
          ]),
        ]),
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "功能选择",
            "append-to-body": true,
            visible: _vm.dialogVisible,
            width: "898",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "function-box" }, [
            _c(
              "div",
              { staticClass: "function-left" },
              _vm._l(_vm.functionLeft, function (item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "function-item",
                    class: {
                      "function-item-active": _vm.functionIndex == index,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.selectFunction(index)
                      },
                    },
                  },
                  [
                    _c("span", [_vm._v(_vm._s(item))]),
                    _c("i", { staticClass: "el-icon-arrow-right" }),
                  ]
                )
              }),
              0
            ),
            _c("div", { staticClass: "function-right" }, [
              _vm.functionIndex == 0
                ? _c("div", { staticClass: "nopage" }, [
                    _c(
                      "div",
                      { staticClass: "select-box select-box-active" },
                      [
                        _c(
                          "el-radio",
                          {
                            attrs: { label: "1" },
                            model: {
                              value: _vm.radio,
                              callback: function ($$v) {
                                _vm.radio = $$v
                              },
                              expression: "radio",
                            },
                          },
                          [_vm._v("不关联页面")]
                        ),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm.functionIndex == 1
                ? _c(
                    "div",
                    { staticClass: "nopage" },
                    _vm._l(_vm.functionInlet, function (item) {
                      return _c(
                        "div",
                        {
                          staticClass: "select-box",
                          class: {
                            "select-box-active":
                              item.label == _vm.functionInletRadio,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.getFunctionName(item.name)
                            },
                          },
                        },
                        [
                          _c(
                            "el-radio",
                            {
                              attrs: { label: item.label },
                              model: {
                                value: _vm.functionInletRadio,
                                callback: function ($$v) {
                                  _vm.functionInletRadio = $$v
                                },
                                expression: "functionInletRadio",
                              },
                            },
                            [_vm._v(_vm._s(item.name))]
                          ),
                        ],
                        1
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm.functionIndex == 2 && _vm.classifyType == "2"
                ? _c(
                    "div",
                    { staticClass: "nopage" },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "margin-bottom": "30px",
                          },
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.tagName,
                                expression: "tagName",
                              },
                            ],
                            staticClass: "search-ipt",
                            attrs: {
                              type: "text",
                              placeholder: "请输入标签名称",
                            },
                            domProps: { value: _vm.tagName },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.tagName = $event.target.value
                              },
                            },
                          }),
                          _c(
                            "el-button",
                            {
                              staticStyle: {
                                height: "36px",
                                "line-height": "normal",
                                "margin-left": "18px",
                              },
                              attrs: { type: "primary", size: "mini" },
                              on: { click: _vm.getLabelList },
                            },
                            [_vm._v("查询")]
                          ),
                        ],
                        1
                      ),
                      _vm._l(_vm.labelList, function (item) {
                        return _c(
                          "div",
                          {
                            staticClass: "select-box",
                            class: {
                              "select-box-active": item.id == _vm.labelId,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.getFunctionName(item.tagName)
                              },
                            },
                          },
                          [
                            _c(
                              "el-radio",
                              {
                                attrs: { label: item.id },
                                model: {
                                  value: _vm.labelId,
                                  callback: function ($$v) {
                                    _vm.labelId = $$v
                                  },
                                  expression: "labelId",
                                },
                              },
                              [_vm._v(_vm._s(item.tagName))]
                            ),
                          ],
                          1
                        )
                      }),
                      _c(
                        "div",
                        {
                          staticClass: "pagibox",
                          staticStyle: {
                            position: "static",
                            "justify-content": "center",
                            "margin-top": "20px",
                          },
                        },
                        [
                          _c("el-pagination", {
                            attrs: {
                              "current-page": _vm.labelPageNo,
                              "page-sizes": [5, 10, 20, 30],
                              "page-size": _vm.labelPageSize,
                              layout: "total, sizes, prev, pager, next, jumper",
                              total: _vm.labelTotalNum,
                            },
                            on: {
                              "size-change": _vm.handleSizeChangeLabel,
                              "current-change": _vm.handleCurrentChangeLabel,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    2
                  )
                : _vm._e(),
              _vm.functionIndex == 2 && _vm.classifyType == "1"
                ? _c("div", { staticClass: "nopage" }, [
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.categoryName,
                              expression: "categoryName",
                            },
                          ],
                          staticClass: "search-ipt",
                          attrs: {
                            type: "text",
                            placeholder: "请输入类目名称",
                          },
                          domProps: { value: _vm.categoryName },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.categoryName = $event.target.value
                            },
                          },
                        }),
                        _c(
                          "el-button",
                          {
                            staticStyle: {
                              height: "36px",
                              "line-height": "normal",
                              "margin-left": "18px",
                            },
                            attrs: { type: "primary", size: "mini" },
                            on: { click: _vm.searchCate },
                          },
                          [_vm._v("查询")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "categary-box" },
                      _vm._l(_vm.rootCategory, function (item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "categary-item",
                            class: {
                              "categary-active": item.id == _vm.rootCategoryId,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.swicthRootCate(item.id, item.name)
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(item.name) + " ")]
                        )
                      }),
                      0
                    ),
                    _c(
                      "div",
                      { staticStyle: { height: "72%", "overflow-y": "auto" } },
                      _vm._l(_vm.category, function (item, index) {
                        return _c(
                          "div",
                          {
                            key: item.id,
                            staticClass: "select-box",
                            class: {
                              "select-box-active": item.id == _vm.categoryId,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.swicthCate(item.id, item.name)
                              },
                            },
                          },
                          [
                            _c(
                              "el-radio",
                              {
                                attrs: { label: item.id },
                                model: {
                                  value: _vm.categoryId,
                                  callback: function ($$v) {
                                    _vm.categoryId = $$v
                                  },
                                  expression: "categoryId",
                                },
                              },
                              [_vm._v(_vm._s(item.name))]
                            ),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "pagibox",
                        staticStyle: { position: "static" },
                      },
                      [
                        _c("el-pagination", {
                          attrs: {
                            "current-page": _vm.catePageNo,
                            "page-sizes": [5, 10, 20, 30],
                            "page-size": _vm.catePageSize,
                            layout: "total, sizes, prev, pager, next, jumper",
                            total: _vm.cateTotalNum,
                          },
                          on: {
                            "size-change": _vm.handleSizeChangecate,
                            "current-change": _vm.handleCurrentChangecate,
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm.functionIndex == 3
                ? _c(
                    "div",
                    {
                      staticClass: "nopage",
                      staticStyle: {
                        position: "relative",
                        width: "100%",
                        height: "100%",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "margin-bottom": "18px",
                          },
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.goodsInfo,
                                expression: "goodsInfo",
                              },
                            ],
                            staticClass: "search-ipt",
                            attrs: {
                              type: "text",
                              placeholder: "请输入商品名称/商品编号",
                            },
                            domProps: { value: _vm.goodsInfo },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.goodsInfo = $event.target.value
                              },
                            },
                          }),
                          _c(
                            "el-button",
                            {
                              staticStyle: {
                                height: "36px",
                                "line-height": "normal",
                                "margin-left": "18px",
                              },
                              attrs: { type: "primary", size: "mini" },
                              on: { click: _vm.searchGoods },
                            },
                            [_vm._v("查询")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: { height: "83%", "overflow-y": "auto" },
                        },
                        _vm._l(_vm.goodsList, function (item) {
                          return _c(
                            "div",
                            {
                              staticClass: "select-box select-goods",
                              class: {
                                "select-box-active":
                                  item.goodsId == _vm.goodsSelectedId,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.getGoodsName(item.goodsName)
                                },
                              },
                            },
                            [
                              _c(
                                "el-radio",
                                {
                                  attrs: { label: item.goodsId },
                                  model: {
                                    value: _vm.goodsSelectedId,
                                    callback: function ($$v) {
                                      _vm.goodsSelectedId = $$v
                                    },
                                    expression: "goodsSelectedId",
                                  },
                                },
                                [
                                  _c("div", { staticClass: "goods-box" }, [
                                    _c("img", {
                                      staticClass: "goods-img",
                                      attrs: { src: item.imgUrl, alt: "" },
                                    }),
                                    _c("div", [
                                      _c("p", [_vm._v(_vm._s(item.goodsName))]),
                                      _c("p", { staticClass: "goods-num" }, [
                                        _vm._v(
                                          "商品编号：" + _vm._s(item.goodsNo)
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          )
                        }),
                        0
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "pagibox",
                          staticStyle: { position: "static" },
                        },
                        [
                          _c("el-pagination", {
                            attrs: {
                              "current-page": _vm.goodsPageNo,
                              "page-sizes": [5, 10, 20, 30],
                              "page-size": _vm.goodsPageSize,
                              layout: "total, sizes, prev, pager, next, jumper",
                              total: _vm.goodsTotalNum,
                            },
                            on: {
                              "size-change": _vm.handleSizeChange,
                              "current-change": _vm.handleCurrentChange,
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
              _vm.functionIndex == 4
                ? _c(
                    "div",
                    { staticClass: "nopage" },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "margin-bottom": "30px",
                          },
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.searchForm.title,
                                expression: "searchForm.title",
                              },
                            ],
                            staticClass: "search-ipt",
                            attrs: {
                              type: "text",
                              placeholder: "请输入页面标题",
                            },
                            domProps: { value: _vm.searchForm.title },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.searchForm,
                                  "title",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          _c(
                            "el-button",
                            {
                              staticStyle: {
                                height: "36px",
                                "line-height": "normal",
                                "margin-left": "18px",
                              },
                              attrs: { type: "primary", size: "mini" },
                              on: {
                                click: function ($event) {
                                  _vm.searchForm.pageNo = 1
                                  _vm.getPageList()
                                },
                              },
                            },
                            [_vm._v("查询")]
                          ),
                        ],
                        1
                      ),
                      _vm._l(_vm.pageList, function (item) {
                        return _c(
                          "div",
                          {
                            staticClass: "select-box",
                            class: {
                              "select-box-active": item.id == _vm.pageId,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.getFunctionName(item.title)
                              },
                            },
                          },
                          [
                            _c(
                              "el-radio",
                              {
                                attrs: { label: item.id },
                                model: {
                                  value: _vm.pageId,
                                  callback: function ($$v) {
                                    _vm.pageId = $$v
                                  },
                                  expression: "pageId",
                                },
                              },
                              [_vm._v(_vm._s(item.title))]
                            ),
                          ],
                          1
                        )
                      }),
                      _c(
                        "div",
                        {
                          staticClass: "pagibox",
                          staticStyle: {
                            position: "static",
                            "justify-content": "center",
                            "margin-top": "20px",
                          },
                        },
                        [
                          _c("el-pagination", {
                            attrs: {
                              "current-page": _vm.searchForm.pageNo,
                              "page-sizes": [5, 10, 20, 30],
                              "page-size": _vm.searchForm.pageSize,
                              layout: "total, sizes, prev, pager, next, jumper",
                              total: _vm.pageTotalNum,
                            },
                            on: {
                              "size-change": _vm.handleSizeChangePage,
                              "current-change": _vm.handleCurrentChangePage,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    2
                  )
                : _vm._e(),
            ]),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.confirmFn } },
                [_vm._v("确 认")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }